import { createContext } from 'react'

export default createContext({ text: '', redirectTo: '' })
